import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Reporting } from "@/savaradio/common";
export const initialLoading = {
  get: false,
  update: false,
}
export type IsLoading = Record<keyof typeof initialLoading, boolean>


const initialState: { value?: Reporting[], isLoading: IsLoading } = { isLoading: initialLoading }

const reportingSlice = createSlice({
  name: "reporting_slice",
  initialState,
  reducers: {
    merge: (state, action: PayloadAction<Reporting>) => {
      if (state.value) state.value = state.value.map(item => item._id === action.payload._id ? action.payload : item)
    },
    append: (state, action: PayloadAction<Reporting>) => {
      if (
        state.value &&
        !state.value.some(item => item._id === action.payload._id)
      ) state.value = state.value.concat(action.payload)
      if (!state.value) state.value = [action.payload]
    },
    reset: (state, action: PayloadAction<Reporting[] | undefined>) => {
      state.value = action.payload
    },
    setLoading: (state, action: PayloadAction<Partial<IsLoading>>) => {
      state.isLoading = {
        ...state.isLoading,
        ...action.payload
      }
    }
  }
})

export const { append, merge, reset, setLoading } = reportingSlice.actions
export const reporting_slice = reportingSlice.reducer